import scrollToElement from "scroll-to-element";

import { getShoppingCartRedirect } from "@utils/configuration/aem";
import { DeliveryTypes } from "@utils/enums";
import { attemptMethod, hasWindow } from "@utils/general";

import { APIStatus } from "@redux/modules/api/data/cart/cart.module";
import { TApiAction } from "@redux/store.types";

const handleMessage = (
    unparsedMessage: any,
    iframe: HTMLIFrameElement,
    addToCartHandler: Function,
    domain: string,
    defaultDeliveryType?: DeliveryTypes,
) => {
    if (!unparsedMessage.data) return;
    const origin = unparsedMessage.origin;
    const isConfigurableProductMessage = origin.includes(domain);
    const isMock = !!unparsedMessage?.data?.isHuboMock;

    if (!(isConfigurableProductMessage || isMock)) return;

    try {
        let message;
        if (isMock) {
            message = JSON.parse(unparsedMessage.data.message);
        } else {
            message = JSON.parse(unparsedMessage.data);
        }

        if (message.products) {
            addToCartHandler(
                message,
                unparsedMessage.origin,
                defaultDeliveryType,
            );
        } else {
            switch (message?.action) {
                case "RESET":
                    scrollToElement(iframe);
                    handleResize(iframe, message.height);
                    break;
                case "RESIZE":
                    handleResize(iframe, message.height);
                    break;
                default:
                    console.log("unknown/unhandled event", message);
            }
        }
    } catch (e: any) {
        console.log(unparsedMessage);
        console.log("unable to parse configurable product message", e.message);
    }
};

const handleResize = (iframe: HTMLIFrameElement, height: string) => {
    iframe.setAttribute("height", height);
};

const createAddToCartResponseForIframe = (
    message: any,
    isSuccessFul: boolean,
) => {
    return (
        message?.products?.map((product: any) => {
            return {
                barcode: product.barcode,
                action: product.action,
                quantity: product.quantity,
                success: isSuccessFul,
            };
        }) || []
    );
};

export const sendSuccessMessage = (
    message: any,
    targetWindow: WindowProxy | null,
    origin: string,
    action: TApiAction,
): void => {
    const isSuccessFul = action?.type === APIStatus.SUCCESS;

    sendMessage(
        targetWindow,
        origin,
        createAddToCartResponseForIframe(message, isSuccessFul),
    );

    if (isSuccessFul) {
        if (hasWindow() && getShoppingCartRedirect()) {
            window.location.href = getShoppingCartRedirect();
        }
    }
};

export const sendFailMessage = (
    message: any,
    targetWindow: WindowProxy | null,
    origin: string,
): void => {
    sendMessage(
        targetWindow,
        origin,
        createAddToCartResponseForIframe(message, false),
    );
};

const sendMessage = (
    targetWindow: WindowProxy | null,
    origin: string,
    message: any,
) => {
    if (targetWindow) {
        targetWindow.postMessage(
            attemptMethod(() => JSON.stringify(message), undefined),
            origin,
        );
    }
};

export { handleMessage };
